const mealCategories = ['AT', 'S', 'R', 'G', 'F', 'L', 'W', 'VT', 'VG']

Date.prototype.iso8601Week = function () {
  // Create a copy of the current date, we don't want to mutate the original
  const date = new Date(this.getTime());

  // Find Thursday of this week starting on Monday
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  const thursday = date.getTime();

  // Find January 1st
  date.setMonth(0); // January
  date.setDate(1);  // 1st
  const jan1st = date.getTime();

  // Round the amount of days to compensate for daylight saving time
  const days = Math.round((thursday - jan1st) / 86400000); // 1 day = 86400000 ms
  return Math.floor(days / 7) + 1;
}

function formatDateString(dateString) {
  // Split the input string into components
  let [day, month, year] = dateString.split('.');
  
  // Rearrange the components to the desired format
  return `${year}-${month}-${day}`;
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}


function getWeekDates() {
  const today = new Date();
  const dayOfWeek = today.getDay();
  
  let startDate;
  let endDate;
  
  if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Monday to Friday
      const daysToLastMonday = dayOfWeek - 1; // Number of days to last Monday
      startDate = new Date(today);
      startDate.setDate(today.getDate() - daysToLastMonday);
      
      const daysToNextFriday = 5 - dayOfWeek;
      endDate = new Date(today);
      endDate.setDate(today.getDate() + daysToNextFriday);
  } else { // Saturday or Sunday
      const daysToNextMonday = (8 - dayOfWeek) % 7; // Number of days to next Monday
      startDate = new Date(today);
      startDate.setDate(today.getDate() + daysToNextMonday);
      
      const daysToNextFriday = 5 - (startDate.getDay() - 1); // Number of days to next Friday
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + daysToNextFriday);
  }
  
  const dates = [];
  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      dates.push(formatDate(new Date(d)));
  }
  
  return dates;
}

function getNextWeekDates() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  
  // Calculate days until next Monday
  const daysToNextMonday = dayOfWeek === 0 ? 1 : (8 - dayOfWeek);
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + daysToNextMonday); // Start of next Monday

  const dates = [];
  for (let i = 0; i < 5; i++) { // Get 5 days from Monday to Friday
    const nextDate = new Date(startDate);
    nextDate.setDate(startDate.getDate() + i);
    dates.push(formatDate(nextDate));
  }
  
  return dates;
};

export function foodCatNames(catNo, locale) {
  if (locale === 'en') {
    switch(catNo){
      case "R":
        return "Beaf / Veal"
      case "S":
        return "Pork"
      case "F":
        return "Fish"
      case "G":
        return "Poultry"
      case "L":
        return "Lamb / Sheep"
      case "W":
        return "Deer"
      case "VT":
        return "Vegetarian"
      case "VG":
        return "Vegan"
      case "AT":
        return "Appropriate animal husbandry"
  }
  }
  switch(catNo){
      case "R":
        return "Rind / Kalb"
      case "S":
        return "Schwein"
      case "F":
        return "Fisch"
      case "G":
        return "Geflügel"
      case "L":
        return "Lamm / Schaf"
      case "W":
        return "Wild"
      case "VT":
        return "Vegetarisch"
      case "VG":
        return "Vegan"
      case "AT":
        return "Artgerechte Tierhaltung"
  }
}


export async function getWeekMeals(location, ln, week, locationid) {
  const order = await getLocationOrder(locationid)
  let days
  if (week === 'next') {
    days = getNextWeekDates()
  } else if (week === 'current') {
    days = getWeekDates()
  }
  let combinedMeals = []
  if (days && days.length) {
    for (const d of days) {
      let kw = new Date(formatDateString(d)).iso8601Week()
      let meals = await getMeals(location, d, ln, locationid, order)
      if (meals) combinedMeals.push({...meals, date: d, kw})
    }
  }
  return combinedMeals
}

export async function getMeals(location, date, ln, locationid, order) {
  const queryObject = {
    query: `page('meals').children.filterBy('location', '${location}').filterBy('date', '${date}').filterBy('printonly', 0)`,
    select: {
      title: true,
      ingredients: "page.ingredients.toObject",
      prices: "page.prices.toObject",
      location: true,
      counter: true,
      date: true,
      mealadds: true,
      mark: true,
      frei3: true,
      printonly: true,
      kombicategory: true,
      categories: "page.categories.split"
    }
  }
  const response = await fetch(import.meta.env.PUBLIC_KIRBY_API_NOCACHE_URL, {
    method: 'post',
    headers: {
      'Content-Type':'application/json',
      'X-Language': `${ln}`,
      'Authorization': `Bearer ${import.meta.env.PUBLIC_KIRBY_API_TOKEN}`
    },
    body: JSON.stringify(queryObject)
  });
  const data = await response.json()
  const mealsWithCategories = data.result.map(m => {
    if (m.mealadds && m.mealadds.length) {
      const intersection = m.mealadds.split(',').filter(add => mealCategories.includes(add.trim()))
      if (intersection && intersection.length) {
        return {
          ...m,
          categories: intersection.map(s => s.trim())
        }
      }
    }
    return m
  })
  if (order) return groupMealsByCounter(mealsWithCategories, order)
  order = await getLocationOrder(locationid)
  return groupMealsByCounter(mealsWithCategories, order)
}

const groupMealsByCounter = async (meals, order) => {

  const grouped = meals.reduce((acc, meal) => {
    // Check if the counter exists in the accumulator
    const counter = acc.find(c => c.label === meal.counter);
    if (counter) {
      // If the counter exists, push the current meal to its meals array
      counter.meals.push(meal);
    } else {
      // If the counter does not exist, create a new counter object
      acc.push({ label: meal.counter, meals: [meal] });
    }
    return acc;
  }, []);

  // Define the sorting order for kombicategory
  const categoryOrder = {
    "Gemüsebeilagen": 1,
    "Sättigungsbeilagen": 2,
    "Hauptkomponente": 3,
  };
  
  // Sort the meals within the "Kombinierbar" group by kombicategory
  grouped.forEach(group => {
    if (group.label === "KombinierBar") {
      group.meals.sort((a, b) => {
        const orderA = categoryOrder[a.kombicategory] || Infinity
        const orderB = categoryOrder[b.kombicategory] || Infinity
        return orderA - orderB;
      });
    }
  });
  if (order && order.length) {
    const getOrderIndex = (label) => {
      // Normalize the label: trim whitespace and convert to lowercase.
      label = label.trim().toLowerCase();
    
      // Force "kombinierbar" (case insensitive) to be last.
      if (label === "kombinierbar") {
        return Infinity;
      }
    
      // Map "ausgabe x" to "angebot x" (case insensitive).
      if (label.startsWith("ausgabe ")) {
        label = label.replace(/^ausgabe/i, "angebot");
      }
    
      // Normalize the order array similarly.
      const normalizedOrder = order.map(item => item.trim().toLowerCase());
      const index = normalizedOrder.indexOf(label);
      return index !== -1 ? index : Infinity;
    };
    
    const sortedGrouped = [...grouped].sort((a, b) => {
      const indexA = getOrderIndex(a.label);
      const indexB = getOrderIndex(b.label);
      return indexA - indexB;
    });

    return sortedGrouped    
  }

  return grouped
}

async function getLocationOrder(locationid) {
  const queryObject = {
    query: `page('${locationid}')`,
    select: {
      categoriestoinclude: {
        query: "page.categoriestoinclude.toStructure"
      }
    }
  }
  const response = await fetch('https://content.stw-bremen.de/api/kql', {
    method: 'post',
    headers: {
      'Content-Type':'application/json',
      'X-Language': 'de',
      'Authorization': 'Bearer SiERWGuZbj/Ud0AqSp21cDX/GIUJqnKG!MgkW-Zg7QzCO0NT1YjkO-N1Bc1aUssM'
    },
    body: JSON.stringify(queryObject)
  });
  const data = await response.json()
  return data.result.categoriestoinclude.map(cat => cat.label)
}

export function generateDayObjects(ln) {
  let days;
  let todaylabel;

  if (ln === 'de') {
    days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    todaylabel = 'Heute';
  } else {
    days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    todaylabel = 'Today';
  }

  const dayObjects = [];
  const today = new Date();
  let count = 0;
  let date = new Date();

  while (count < 10) {
    const dayLabel = date.getDay();

    // Skip Saturdays (6) and Sundays (0)
    if (dayLabel !== 6 && dayLabel !== 0) {
      const isoDate = date.toISOString().split('T')[0];
      const formatDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      
      const label = `${days[dayLabel]}, ${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}`;

      dayObjects.push({ label, isoDate, formatDate });
      count++;
    }

    // Move to the next day
    date.setDate(date.getDate() + 1);
  }

  return dayObjects;
}

export function isToday(dateString) {
  const today = new Date().toISOString().split('T')[0]; // Get today's date in yyyy-mm-dd format
  return dateString === today;
}


export function addSwitch(add, ln) {
  if (ln === 'en') {
    switch (add) {
      case "1":
        return "with colouring";
      case "2":
        return "with preservatives";
      case "3":
        return "with antioxidant";
      case "4":
        return "with phosphate";
      case "5":
        return "with sweetener";
      case "6":
        return "with a source of phenylalanine";
      case "7":
        return "blackened";
      case "8":
        return "sulphured";
      case "9":
        return "waxed";
      case "10":
        return "with alcohol";
      case "11":
        return "with flavour enhancer";
      case "12":
        return "with caffeine";
      case "13":
        return "containing animal rennet";
      case "S":
        return "pork";
      case "a1":
        return "wheat";
      case "a2":
        return "rye";
      case "a3":
        return "barley";
      case "a4":
        return "oat";
      case "a5":
        return "spelt";
      case "a6":
        return "kamut";
      case "b":
        return "crustaceans & products thereof";
      case "c":
        return "eggs & products thereof";
      case "d":
        return "fish & products thereof";
      case "e":
        return "peanuts & products thereof";
      case "f":
        return "soybeans & products thereof";
      case "g":
        return "milk & dairy products, including lactose";
      case "h1":
        return "almonds";
      case "h2":
        return "hazelnuts";
      case "h3":
        return "walnuts";
      case "h4":
        return "cashew nuts";
      case "h5":
        return "pecans";
      case "h6":
        return "Brazil nuts";
      case "h7":
        return "pistachio";
      case "h8":
        return "macadamia";
      case "i":
        return "celery & products thereof";
      case "j":
        return "mustard & products thereof";
      case "k":
        return "sulphur oxide & sulfide at conc. of > 10mg/kg or 10mg/l";
      case "l":
        return "lupine & products thereof";
      case "m":
        return "sesame seeds & products thereof";
      case "n":
        return "molluscs & products thereof";
      case "R":
        return "beaf / veal";
      case "artG":
        return "Appropriate animal husbandry";
      default:
        return add;
    }
  }
  switch (add) {
    case "1":
      return "mit Farbstoff";
    case "2":
      return "mit Konservierungsstoff";
    case "3":
      return "mit Antioxidationsmittel";
    case "4":
      return "mit Phosphat";
    case "5":
      return "mit Süßungsmitteln";
    case "6":
      return "mit einer Phenylalaninquelle";
    case "7":
      return "geschwärzt";
    case "8":
      return "geschwefelt";
    case "9":
      return "gewachst";
    case "10":
      return "mit Alkohol";
    case "11":
      return "mit Geschmacksverstärker";
    case "12":
      return "koffeinhaltig";
    case "13":
      return "enthält tierisches Lab";
    case "S":
      return "Schwein";
    case "a1":
      return "Weizen";
    case "a2":
      return "Roggen";
    case "a3":
      return "Gerste";
    case "a4":
      return "Hafer";
    case "a5":
      return "Dinkel";
    case "a6":
      return "Kamut";
    case "b":
      return "Krebstiere & Krebstiererzeugnisse";
    case "c":
      return "Eier & Eiererzeugnisse";
    case "d":
      return "Fisch & Fischerzeugnisse";
    case "e":
      return "Erdnüsse & Erdnusserzeugnisse";
    case "f":
      return "Soja & Sojaerzeugnisse";
    case "g":
      return "Milch & Milcherzeugnisse (inklusive Laktose)";
    case "h1":
      return "Mandeln";
    case "h2":
      return "Haselnüsse";
    case "h3":
      return "Walnüsse";
    case "h4":
      return "Kaschunüsse";
    case "h5":
      return "Pecannüsse";
    case "h6":
      return "Paranüsse";
    case "h7":
      return "Pistazien";
    case "h8":
      return "Macadamia";
    case "i":
      return "Sellerie & Sellerieerzeugnisse";
    case "j":
      return "Senf & Senferzeugnisse";
    case "k":
      return "Schwefeldioxide & Sulfide (Konz. > 10mg/kg od. 10mg/l)";
    case "l":
      return "Lupine & Lupinenerzeugnisse";
    case "m":
      return "Sesamsamen & Sesamsamenerzeugnisse";
    case "n":
      return "Weichtiere & Weichtiererzeugnisse";
    case "R":
      return "Rind / Kalb";
    case "artG":
      return "Artgerechte Tierhaltung";
    default:
      return add;
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertDate(dateString) {
  // Split the input date string (YYYY-MM-DD) into an array [YYYY, MM, DD]
  const parts = dateString.split('-');
  
  // Rearrange the parts and format them as DD.MM.YYYY
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}

export function checkForCounters(obj) {
  const allowedProps = ["kw", "date"]
  return Object.keys(obj).some(key => !allowedProps.includes(key))
}

export function findOptionByValue(data, searchValue) {
  for (const group of data) {
    const found = group.options.find(option => {
      return option.value === searchValue
    });
    if (found) {
      return found.id;
    }
  }
  return null;
}